import React, { useEffect } from 'react';
import { StyledLeafletSharePopup } from './styles';
import { SlideUpPopupWrapper } from 'src/components/Popup/components/SlideUpPopup';
import { E_POPUP_STATE } from 'src/utils/enum';
import Dim from 'src/components/Dim';
import { ICON_PATH, IS_LEAFLET_TYPE } from 'src/utils/constants';
import { bridgeSendSms, bridgeSetToastPopup } from 'src/utils/bridge';
import CopyToClipboard from 'react-copy-to-clipboard';
import { leafletGaEvent, leafletGaPageView } from 'src/utils/ga';
import { useLocation } from 'react-router-dom';

type TProps = {
  isOpen: E_POPUP_STATE;
  onClose: () => void;
  tabIndex: number;
  kakaoShareImage: string;
};
/**
 *@name 전단 공유하기 팝업
 *@description 현URL + tabIndex={현재페이지Index}
 */
function LeafletSharePopup(props: TProps): React.ReactElement {
  const location = useLocation();
  const userAgent = navigator.userAgent.toLocaleLowerCase();

  const browser = navigator.userAgent.toLowerCase();

  const appParams = window.location.search.includes('rst1') ? '' : '&rst1=J';
  const appBaseUrl =
    `${process.env.REACT_APP_BASE_FRONT_ORIGIN}/system/launcher?_route=` +
    window.location.pathname +
    window.location.search +
    '&hfrom=APP' +
    appParams;
  const webBaseUrl = window.location.href;
  const webParams = window.location.href.includes('?') ? '&' : '?';

  // 마트고 : 외부진입 URL, 웹전단 : 현 URL
  const shareUrl = IS_LEAFLET_TYPE
    ? appBaseUrl + webParams + `tabIndex=${props.tabIndex}`
    : webBaseUrl + webParams + `tabIndex=${props.tabIndex}`;

  // 카카오톡 공유
  const handleClickKakaoShare = () => {
    setGaEvent('전단 공유하기(카카오톡)');
    const _shareUrl = shareUrl + '&rst2=KAKAO';
    window.Kakao.Share.sendDefault({
      objectType: 'feed',
      content: {
        imageWidth: 800,
        imageHeight: 400,
        title: '이번주 전단 행사 안내',
        description: '이번주 행사 내용 확인하고 롯데마트/슈퍼로!',
        imageUrl: `${props.kakaoShareImage}`,
        link: {
          mobileWebUrl: _shareUrl,
          webUrl: _shareUrl,
        },
      },
      buttons: [
        {
          title: '전단 보러가기',
          link: {
            mobileWebUrl: _shareUrl,
            webUrl: _shareUrl,
          },
        },
      ],
    });
  };

  // URL 복사
  const handleClickUrlShare = () => {
    setGaEvent('전단 공유하기(URL복사)');
    // 안드로이드 13버전 기본 문구 중복 예외처리
    if (parseFloat(browser.substring(browser.indexOf('android') + 8)) >= 13) {
      return;
    } else {
      bridgeSetToastPopup('클립보드에 복사되었습니다.');
    }
  };

  // 문자 공유(웹)
  const sendSms = _shareUrl => {
    let sendTag;
    let encodingUrl;
    if (userAgent.search('android') > -1) {
      encodingUrl = _shareUrl.replace(/&/gi, '%2526');
      sendTag = 'sms:?body';
    } else if (/iPhone|iPad|iPod|safari/i.test(userAgent)) {
      encodingUrl = encodeURIComponent(_shareUrl);
      sendTag = 'sms:&body';
    }

    return sendTag + `=${encodingUrl}`;
  };

  // 문자 공유
  const handleClickTextShare = () => {
    setGaEvent('전단 공유하기(문자공유)');
    const _shareUrl = shareUrl + '&rst2=SMS';
    if (IS_LEAFLET_TYPE) {
      bridgeSendSms(_shareUrl);
    } else {
      const shareTest = sendSms(_shareUrl);

      window.location.href = shareTest;
    }
  };

  const setGaEvent = (title: string) => {
    const pageName = '전단공유팝업';
    leafletGaEvent(pageName, title);
  };

  useEffect(() => {
    leafletGaPageView('전단공유팝업', location.pathname);
  }, [location]);

  return (
    <>
      <Dim isDisplay={props.isOpen === E_POPUP_STATE.OPEN} zIndex={101} />
      <SlideUpPopupWrapper isOpen={props.isOpen} overflow="N">
        <StyledLeafletSharePopup>
          <button
            className="close_btn"
            onClick={props.onClose}
            aria-label="닫기"
          >
            <img src={`${ICON_PATH}/icon_appcard_close.png`} alt="" />
          </button>
          <div className="card_header" onClick={props.onClose} aria-hidden>
            <div />
          </div>
          <div className="card_box">
            <h2>공유하기</h2>
            <ul>
              <li onClick={handleClickKakaoShare}>
                <img src={`${ICON_PATH}/icon_shareKakao.png`} alt="" />
                <p>카카오톡</p>
              </li>
              <CopyToClipboard
                text={shareUrl + '&rst2=URL'}
                onCopy={handleClickUrlShare}
              >
                <li>
                  <img src={`${ICON_PATH}/icon_copyUrl.png`} alt="" />
                  <p>URL복사</p>
                </li>
              </CopyToClipboard>
              <li onClick={handleClickTextShare}>
                <img src={`${ICON_PATH}/icon_sms.png`} alt="" />
                <p>메시지</p>
              </li>
            </ul>
          </div>
        </StyledLeafletSharePopup>
      </SlideUpPopupWrapper>
    </>
  );
}

export default LeafletSharePopup;
